import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery } from '@apollo/client'
import { isEmpty } from 'lodash'

import { Autocomplete } from 'components/v2/Autocomplete'
import { GTSiteAutocomplete } from 'gql/types.generated'
import { GET_SITES_AUTOCOMPLETE } from 'features/Sites/queries-legacy'
import { SITES_AUTOCOMPLETE_LIMIT } from 'features/Sites/constants'

const messages = defineMessages({
  error: {
    id: 'sites.autocomplete.error',
    defaultMessage: 'There was an issue while loading your sites'
  },
  empty: {
    id: 'sites.autocomplete.empty',
    defaultMessage: 'No sites found'
  }
})

export const SiteAutocomplete = ({ ...props }): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')
  const { data, loading, error, refetch } = useQuery(GET_SITES_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      limit: SITES_AUTOCOMPLETE_LIMIT
    }
  })

  useEffect(() => {
    refetch()
  }, [])

  const shownItems =
    (data &&
      !isEmpty(data.sitesAutocomplete) &&
      data.sitesAutocomplete.filter((site: TSFixMe) => {
        return site.name.toLowerCase().indexOf(pattern.toLowerCase()) > -1
      })) ||
    []

  const handleChange = (site: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(site)) {
      props.onChange(site)
    } else {
      props.onChange({
        id: '',
        name: ''
      })
    }
  }

  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(site: GTSiteAutocomplete): string => site.name}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
